import { render, staticRenderFns } from "./LabelModal3.vue?vue&type=template&id=30bce167&scoped=true&"
import script from "./LabelModal3.vue?vue&type=script&lang=js&"
export * from "./LabelModal3.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal3.vue?vue&type=style&index=0&id=30bce167&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal3.vue?vue&type=style&index=1&id=30bce167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bce167",
  null
  
)

export default component.exports